module.exports = __webpack_public_path__ + "img/portfolio-08-01-670x479.b65dce66.jpg";